// AsistenteDemo.jsx
// Sección de la landing dedicada al Asistente: el reel con la app real, tres
// argumentos, la comparativa contra una IA genérica y el CTA de descarga.
//
// Aquí NO va <ChatWayo />. Lo tuvo hasta el 2026-07-25, pero contaba la misma
// conversación que el reel (mismos datos de Lucía) en una recreación web, y dos
// chats seguidos se restaban. El chat sigue vivo en la burbuja flotante
// <AsistenteFab />, que es donde tiene sentido: ahí se puede trastear.
import React from "react";
import AsistenteReel from "./AsistenteReel";
import "./AsistenteDemo.css";
import appStoreImg from "../assets/img/app-store.png";
import googlePlayImg from "../assets/img/google.store.png";
import { trackAppStoreClick, trackGooglePlayClick } from "../analytics/googleAnalytics";

export default function AsistenteDemo() {
  return (
    <section className="asistente" id="asistente">
      <div className="asistente-inner">
        <header className="asistente-header">
          <span className="asistente-badge">Asistente Wayo</span>
          <h2 className="asistente-title">
            No cuenta calorías.
            <br />
            <span className="title-highlight">Te dice qué hacer con ellas</span>
          </h2>
          <p className="asistente-sub">
            Pregúntale lo que quieras. Wayo ya sabe tu objetivo, tus macros y lo que llevas comido
            hoy.
          </p>
        </header>

        {/* El reel es la prueba: la app de verdad, con capturas reales de
            Recetario y Entrenamientos. Arranca al entrar en pantalla. */}
        <AsistenteReel />

        {/* Primero se ve (el reel), después se lee: tres argumentos en fila y
            la comparativa debajo, a ancho completo. Repiten a propósito el
            mensaje del reel, para quien escanea la página sin ver el vídeo. */}
        <div className="asistente-argumento">
          <ul className="asistente-lista">
            <li>
              <strong>Sabe lo que has comido hoy.</strong> Cada respuesta sale de tus comidas
              registradas, tus macros y tu plan. No de consejos genéricos.
            </li>
            <li>
              <strong>Te lleva a la acción.</strong> Si te propone una cena, te abre la receta. Si
              te propone entrenar, te abre la rutina.
            </li>
            <li>
              <strong>Está donde comes.</strong> Registras el plato con una foto o contándoselo, y preguntas por él
              en la misma app, sin copiar y pegar nada.
            </li>
          </ul>

          <div className="versus">
            <div className="versus-col versus-otros">
              <span className="versus-quien">Le preguntas a una IA genérica</span>
              <p className="versus-cita">
                “Depende de tus objetivos y de lo que hayas comido durante el día. En general, una
                cena equilibrada debería incluir proteína, verdura...”
              </p>
              <span className="versus-veredicto">No sabe nada de ti</span>
            </div>
            <div className="versus-col versus-wayo">
              <span className="versus-quien">Le preguntas a Wayo</span>
              <p className="versus-cita">
                “Te quedan 430 kcal y te faltan 42 g de proteína. Salmón al horno con brócoli y
                media patata: 410 kcal y 39 g.”
              </p>
              <span className="versus-veredicto">Sabe lo que llevas comido</span>
            </div>
          </div>
        </div>

        <div className="asistente-cta">
          <div className="asistente-trial">
            <strong>El Asistente está incluido en los 7 días Premium gratis</strong>
          </div>
          <div className="store-badges">
            <a
              href="https://apps.apple.com/app/id6756500478"
              className="store-badge app-store"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackAppStoreClick("asistente")}
            >
              <img src={appStoreImg} alt="App Store" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.facundosolis.wayo"
              className="store-badge google-play"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackGooglePlayClick("asistente")}
            >
              <img src={googlePlayImg} alt="Google Play" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
